<template>
  <div id="app" class="app" :class="{ '--level': level, ['--level-' + level]: level }">
    <div class="app__top" :class="{ '--shown': isShareShown }">
      <div class="app__top-logo">
        <a class="app__top-logo-img" target="_blank" href="https://www.vedomosti.ru/">
          <img v-if="!level" src="./assets/vedomosti-logo.svg" />
          <img v-if="level" src="./assets/vedomosti-logo-white.svg" />
          <img class="--mobile --wide" src="./assets/vedomosti-logo-white.svg" />
          <img class="--mobile" src="./assets/vedomosti-logo-mobile.svg" />
        </a>
        <a
          class="app__top-logo-img button-tracked"
          target="_blank"
          href="https://megafon.ru/corporate/productsandsolutions/products/mobilnaya_elektronnaya_podpis.html?utm_source=vedomosti&utm_medium=game&utm_campaign=vedomosti-mep-2019&utm_content=logo#description"
          @click="logoClick"
        >
          <img v-if="!level" src="./assets/megafon-logo.svg" />
          <img v-if="level" src="./assets/megafon-logo-white.svg" />
          <img class="--mobile --wide" src="./assets/megafon-logo-white.svg" />
          <img class="--mobile" src="./assets/megafon-logo-mobile.svg" />
        </a>
      </div>
      <div class="app__top-header">
        Подпишите это быстрее!
      </div>
      <div class="app__top-socials">
        <span class="app__top-social" @click="$root.$emit('share', 'fb')">
          <img v-if="!level" src="./assets/fb.svg" alt="" />
          <img v-if="level" src="./assets/fb-w.svg" alt="" />
        </span>
        <span class="app__top-social" @click="$root.$emit('share', 'vk')">
          <img v-if="!level" src="./assets/vk.svg" alt="" />
          <img v-if="level" src="./assets/vk-w.svg" alt="" />
        </span>
        <span class="app__top-social" @click="$root.$emit('share', 'tw')">
          <img v-if="!level" src="./assets/tw.svg" alt="" />
          <img v-if="level" src="./assets/tw-w.svg" alt="" />
        </span>
        <span class="app__top-social --mobile">
          <img src="./assets/share.svg" alt="" @click="isShareShown = !isShareShown" id="mobile-share" />
          <div class="app__top-social-mobile-list">
            <span class="app__top-social-mobile-item" @click="$root.$emit('share', 'fb')">
              <img src="./assets/fb-v.svg" alt="" />
            </span>
            <span class="app__top-social-mobile-item" @click="$root.$emit('share', 'vk')">
              <img src="./assets/vk-v.svg" alt="" />
            </span>
            <span class="app__top-social-mobile-item" @click="$root.$emit('share', 'tw')">
              <img src="./assets/tw-v.svg" alt="" />
            </span>
          </div>
        </span>
      </div>
    </div>
    <div class="app__header">
      <div class="app__header-special">Спецпроект</div>
      <h2>Подпишите это быстрее!</h2>
      <p>
        Получив MBA в престижном западном вузе, вы начали активный поиск вакансий на позицию CEO. Внезапно вам пришло
        приглашение стать директором фабрики по производству деревянных треугольных линеек. Ваша задача — привести в
        качестве гендиректора ООО «Деревянные треугольные линейки» к успеху!
      </p>
    </div>
    <Game></Game>
    <About></About>
  </div>
</template>

<script>
import Game from './components/Game.vue'
import About from './components/About'

export default {
  name: 'app',
  data() {
    return {
      level: 0,
      isShareShown: false,
    }
  },
  components: {
    About,
    Game,
  },
  methods: {
    onLevel(level) {
      this.level = level
    },
    onShare(social) {
      const url = 'http://megafon.vedomosti.ru/'

      const urls = {
        fb: `https://www.facebook.com/sharer/sharer.php?u=${url}`,
        tw: `https://twitter.com/intent/tweet?url=${url}`,
        vk: `http://vk.com/share.php?url=${url}`,
      }

      const shareUrl = urls[social]
      window.open(shareUrl)
    },
    logoClick() {
      window.gtag('event', 'click_to_mep', { event_category: 'button', event_label: 'logo' })
    }
  },
  mounted() {
    this.$root.$on('level', this.onLevel)
    this.$root.$on('share', this.onShare)
    window.document.addEventListener('click', e => {
      if (this.isShareShown && e.target.id !== 'mobile-share') {
        this.isShareShown = false
      }
    })
  },
}
</script>

<style lang="scss">
html,
body {
  padding: 0;
  margin: 0;
  font-family: 'Roboto', sans-serif;
  color: #000;
  -webkit-font-smoothing: antialiased;
  background: #fbede5;
  overflow: hidden;
}

* {
  box-sizing: border-box;
}

button {
  cursor: pointer;
  outline: none;
  border: none;
  transition: transform 0.3s ease-in-out;

  &:active {
    transform: scale(0.95);
  }
}

.app {
  width: 100vw;
  min-height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  line-height: 0;

  background: none;

  @media (min-width: 768px) and (min-height: 1024px), (min-height: 768px) and (min-width: 1024px) {
    /*min-height: 768px;*/
    &.--level-1 {
      background: url(./assets/bg/level1.jpg) no-repeat center center;
    }
    &.--level-2 {
      background: url(./assets/bg/level2.jpg) no-repeat center center;
    }
    &.--level-3 {
      background: url(./assets/bg/level3.jpg) no-repeat center center;
    }

    &.--level {
      background-size: cover;
      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.8));
      }
    }
  }

  &__top {
    display: flex;
    justify-content: space-between;
    position: absolute;
    color: #fff;
    top: 0;
    left: 0;
    height: 39px;
    line-height: 39px;
    width: 100%;
    background-color: #731982;

    padding: 0 10px;
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.5);
    z-index: 3;

    .app__top-social-mobile-list {
      display: none;
    }

    &.--shown {
      .app__top-logo {
        display: none;
      }
      .app__top-social {
        &.--mobile {
          display: flex;
          width: auto;
          height: 39px;
          align-items: center;
        }
        &-mobile-list {
          display: flex;
          align-items: center;
        }

        &-mobile-item {
          margin: 0 0 0 10px;
          width: 20px;
          height: 20px;
        }
      }
    }

    @media (min-width: 1024px) {
      .app__top-social {
        &.--mobile {
          display: flex;
          width: auto;
          height: 39px;
          align-items: center;

          > img {
            display: none;
          }
        }
        &-mobile-list {
          display: flex;
          align-items: center;
        }

        &-mobile-item {
          margin: 0 0 0 10px;
          width: 20px;
          height: 20px;
        }
      }
    }

    @media (min-width: 768px) and (min-height: 1024px), (min-height: 768px) and (min-width: 1024px) {
      &.--shown {
        .app__top-logo {
          display: block;
        }
        .app__top-social {
          &.--mobile {
            display: none;
          }
        }
      }
    }

    @media (min-width: 768px) and (min-height: 1024px), (min-height: 768px) and (min-width: 1024px) {
      top: 30px;
      left: 30px;
      right: 30px;
      height: 26px;
      line-height: 26px;
      background: transparent;
      width: auto;
      padding: 0;
      box-shadow: none;
    }

    &-header {
      font-size: 15px;
      font-weight: 500;

      @media (min-width: 1024px) {
        font-size: 16px;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
      }

      @media (min-width: 768px) and (min-height: 1024px), (min-height: 768px) and (min-width: 1024px) {
        display: none;
      }
    }

    &-logo {
      display: flex;
      height: inherit;
      align-items: center;
    }

    &-logo-img {
      display: inline-block;
      width: 26px;
      height: 26px;

      position: relative;
      &:first-child {
        margin-right: 21px;
        &::after {
          content: '';
          height: 30px;
          width: 1px;
          background: rgba(255, 255, 255, 0.25);
          position: absolute;
          top: -2px;
          right: -10px;
        }
      }

      img {
        display: none;
        &.--mobile {
          display: inline-block;

          &.--wide {
            display: none;
          }

          @media (min-width: 1024px) {
            display: none;

            &.--wide {
              display: block;
            }
          }
        }
      }

      @media (min-width: 1024px) {
        width: auto;
        margin-top: -1px;
        &:first-child {
          margin-right: 41px;
          height: auto;
          margin-top: 0;
          &::after {
            content: '';
            height: 26px;
            width: 1px;
            background: rgba(255, 255, 255, 0.5);
            position: absolute;
            top: -3px;
            right: -20px;
          }
        }
      }

      @media (min-width: 768px) and (min-height: 1024px), (min-height: 768px) and (min-width: 1024px) {
        vertical-align: top;
        position: relative;
        width: auto;
        height: 26px;

        &:first-child {
          margin-right: 41px;
          margin-left: 0;
          margin-top: 0;
          &::after {
            content: '';
            height: 26px;
            width: 1px;
            background: #e6d0c5;
            position: absolute;
            top: 0;
            right: -20px;
          }
        }

        img {
          display: inline-block;
          vertical-align: middle;
          &.--mobile {
            display: none;
            &.--wide {
              display: none;
            }
          }
        }
      }
    }

    &-socials {
      line-height: 36px;

      @media (min-width: 768px) and (min-height: 1024px), (min-height: 768px) and (min-width: 1024px) {
        line-height: 20px;
        display: flex;
        flex-direction: column;
      }
    }

    &-social {
      display: none;
      line-height: 20px;
      height: 20px;
      width: 20px;
      vertical-align: middle;
      text-align: center;
      cursor: pointer;
      &.--mobile {
        display: inline-block;
      }
      img {
        vertical-align: middle;
      }

      @media (min-width: 768px) and (min-height: 1024px), (min-height: 768px) and (min-width: 1024px) {
        margin-bottom: 30px;
        display: inline-block;
        &.--mobile {
          display: none !important;
        }
      }
    }
  }

  &__header {
    color: #04b358;
    position: absolute;
    top: 84px;
    left: 30px;
    display: none;

    &-special {
      line-height: 18px;
      font-size: 14px;
      margin-bottom: 10px;
    }

    > p {
      margin: 15px 0 0;
      font-size: 16px;
      line-height: 20px;
      color: #000;
      max-width: 650px;
    }

    h2 {
      font-size: 30px;
      line-height: 30px;
      font-weight: 900;
      margin: 0;
      padding: 0;
      width: auto;
    }

    @media (min-width: 768px) and (min-height: 1024px), (min-height: 768px) and (min-width: 1024px) {
      display: block;
    }

    @media (min-width: 1024px) and (min-height: 768px) {
      top: 96px;
      width: 450px;
      &-special {
        font-size: 14px;
      }
      h2 {
        font-size: 50px;
        line-height: 60px;
        width: 360px;
        margin-bottom: 30px;
      }
      p {
        font-size: 18px;
        line-height: 30px;
      }
    }

    @media (min-width: 1280px) and (min-height: 800px) {
      top: 95px;

      h2 {
        width: 318px;
        font-size: 50px;
        line-height: 60px;
        margin-bottom: 30px;
      }
    }

    @media (min-width: 1920px) {
      width: 50%;
      &-special {
        font-size: 16px;
        line-height: 20px;
      }
      h2 {
        font-size: 70px;
        line-height: 80px;
        width: auto;
        max-width: 500px;
      }

      p {
        font-size: 20px;
        line-height: 30px;
        max-width: 700px;
      }
    }
  }

  > .about {
    display: none;

    @media (min-width: 768px) and (min-height: 1024px), (min-height: 768px) and (min-width: 1024px) {
      display: block;
      position: absolute;
      bottom: 20px;
      left: 30px;
      right: 30px;
      max-width: 170px;

      p {
        font-size: 14px;
        line-height: 20px;
        color: #000;
        &.--active {
          max-height: 190px;
        }
      }
    }

    @media (min-width: 1024px) and (min-height: 768px) {
      max-width: 400px;
      p.--active {
        max-height: 120px;
      }
    }

    @media (min-width: 1280px) and (min-height: 800px) {
      p.--active {
        max-height: 120px;
      }
    }
  }

  &.--level {
    @media (min-width: 768px) and (min-height: 1024px), (min-height: 768px) and (min-width: 1024px) {
      .app__top-logo-img:first-child::after {
        background: rgba(255, 255, 255, 0.25);
      }
      .about p {
        color: #fff;
      }

      .app__top-socials {
        flex-direction: row;
        line-height: 26px;
        align-items: center;
      }
      .app__top-social {
        margin: 0 0 0 20px;
      }

      .app__header {
        top: 70px;
        color: #fff;

        p {
          display: none;
        }
      }
    }

    @media (min-width: 1024px) and (min-height: 768px) {
      .app__header {
        top: 88px;
        color: #fff;

        h2 {
          font-size: 40px;
          line-height: 40px;
          width: 255px;
        }

        p {
          display: none;
        }
      }
      .about {
        max-width: 255px;
      }
      .about p.--active {
        max-height: 100px;
      }
    }

    @media (min-width: 1280px) and (min-height: 800px) {
      .about {
        max-width: 400px;
      }
      .app__header {
        top: 95px;
        h2 {
          font-size: 50px;
          line-height: 60px;
          width: 320px;
        }
      }
    }

    @media (min-width: 1920px) {
      .app__header {
        width: 500px;
        &-special {
          font-size: 16px;
          line-height: 20px;
        }
        h2 {
          font-size: 70px;
          line-height: 80px;
          width: auto;
        }
      }
    }
  }
}
</style>
